<script>
import { AgGridVue } from '@ag-grid-community/vue'
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model'
// import { AllModules } from '@ag-grid-community/all-modules';

import airlineLogoRenderer from '@src/components/grid/airlineLogoRenderer.js'
import imageUpload from '@src/components/grid/imageUploadCellEditor.js'

import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
// import Empty from '@src/components/shared/empty.vue'

import menuRoutes from '@router/menuRoutes.js'

// import Grid from '@components/grid.vue'

import axios from 'axios'

const filterObj = {
  filter: 'agTextColumnFilter',
  filterParams: {
    applyButton: false,
    resetButton: true,
  },
  resizable: true,
  sortable: true,
}
const columnDefs = [
  {
    field: 'AirlineCode',
    headerName: 'AirlineCode',
    pinned: true,
    width: 250,
    ...filterObj,
    cellClass: 'center-cell',
  },
  {
    field: 'AirlineGroupId',
    headerName: 'AirlineGroupId',
    ...filterObj,
    cellClass: 'center-cell',
  },
 {
    field: 'CheckInEnabled',
    headerName: 'CheckInEnabled',
    ...filterObj,
    cellClass: 'center-cell',
  },
  {
    field: 'BagTagPrintingEnabled',
    headerName: 'BagTagPrintingEnabled',
    ...filterObj,
    cellClass: 'center-cell',
  },
  {
    field: 'MaxGroupSize',
    headerName: 'MaxGroupSize',
    ...filterObj,
    cellClass: 'center-cell',
  },
]

const idFunc = (row) => {
  return row.MenuAirlineId
}

export default {
  page: {
    title: 'Airline Menus',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, AgGridVue },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      routesPax: menuRoutes.navRoutePaxTotals,
      data: null,
      isLoading: false,
      columnDefs: columnDefs,
      getRowNodeId: idFunc,
      gridOptions: null,
      gridApi: null,
      modules: [ClientSideRowModelModule],
    }
  },
  created() {
    this.getData()
  },
  beforeMount() {
    this.gridOptions = {}
    this.frameworkComponents = {
      airlineLogo: airlineLogoRenderer,
      imageUpload: imageUpload,
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
  },
  methods: {
    onGridReady(params) {},
    getData() {
      this.isLoading = true
      const body = {
        Airport: 'LEJ',
      }
      axios
        .post(`${this.$config.apiBaseUrl}kioskManage/getairlines`, body)
        .then((response) => {
          const data = response.data.Results[0]
          // Update the timestamp
          this.data = data
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => (this.isLoading = false))
    },
    onRowEditingStopped(params) {
      
      // const user = params.data;

      this.isLoading = true

      const config = { headers: { 'Content-Type': 'multipart/form-data' } }
      const data = new FormData()
      data.append('sourceFileName', params.data.AirlineLogo)

      axios
        .post(
          `${this.$config.apiBaseUrl}kioskManage/addmenuairline/airline/${params.data.AirlineName}/code/${params.data.AirlineIcaoCode}/filename/${params.data.AirlineLogo.name}/`,
          data,
          config
        )
        .then((response) => {
         this.getData();
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<template>
  <Layout>
    <div style="text-align: center; ">
      <!-- <h4>You have no kiosks registered</h4>
      <Empty style="max-height: 60vh; margin-top: 3rem;" />-->
      <!-- <Grid :column-defs="columnDefs" :grid-data="kiosks" :resize-headers="false" id-key="KioskName" /> -->

      <div style="height: 100%">
        <div style="height: 100%; box-sizing: border-box;">
          <div class="toolbar row p-2">
            <!-- v-if="$resize && $mq.above(992)" -->
            <div class="col-md-2">
              <input
                v-model="paxFilter"
                class="form-control form-control-sm"
                type="text"
                placeholder="Flights Search (All Columns)"
              />
            </div>

            <div class="col-md-7">
              <button
                class="btn btn-sm btn-dark btn-refresh mr-2"
                :disabled="isLoading"
                @click="getData"
                >Test</button
              >
            </div>
          </div>
          <AgGridVue
            id="myGrid"
            style="width: 100%; height: 83vh;"
            class="ag-theme-alpine"
            :grid-options="gridOptions"
            edit-type="fullRow"
            row-height="70"
            :row-data="data"
            :modules="modules"
            :column-defs="columnDefs"
            :framework-components="frameworkComponents"
            enable-cell-change-flash
            delta-row-data-mode
            :get-row-node-id="getRowNodeId"
                  suppress-cell-selection
                     @grid-ready="onGridReady"
      @row-editing-stopped="onRowEditingStopped"
          ></AgGridVue>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
.center-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  align-self: center;
  height: 100%;
  img {
    max-height: 45px;
    width: 100%;
  }
}

.avatar-container {
    border: 0;
    width: 135px;
    background: #607D8B;
    padding: 0.5rem 1rem;
    box-shadow: unset;
    outline: unset;
    .backdrop {
    background: #8BC34A;
    font-size: 1rem;
    border-radius: 3px;
}
}
</style>
